import { createSelector } from 'reselect';

import type { ApiErrorState } from 'modules/customers/reducers/ui/leads/unsubscribe/apiError';
import { getUI } from './index';

const getLeads = createSelector(getUI, (ui) => ui.leads);

const getUnsubscribe = createSelector(getLeads, (leads) => leads.unsubscribe);

const getError = createSelector(getUnsubscribe, (unsubscribe): ApiErrorState => unsubscribe.apiError);

export const hasError = createSelector(getError, (error) => Boolean(error));

export const is404Error = createSelector(getError, (error) => typeof error === 'object' && error?.errorCode === 404);

export const isReady = createSelector(getUnsubscribe, (unsubscribe) => unsubscribe.isReady);
